var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "details",
    {
      staticClass: "registry-contacts mt-2",
      attrs: { open: _vm.expanded },
      on: { toggle: _vm.toggle },
    },
    [
      _c("summary", { staticClass: "small" }, [
        _vm._v("Contacts (" + _vm._s(_vm.total) + ")"),
        _vm.candidateTotal
          ? _c("span", { staticClass: "text-muted" }, [
              _vm._v(" · " + _vm._s(_vm.candidateTotal) + " possible only"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "p",
            { staticClass: "small text-muted mt-2", attrs: { role: "status" } },
            [_vm._v("Loading contacts…")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c(
            "div",
            { staticClass: "small text-danger mt-2", attrs: { role: "alert" } },
            [
              _vm._v(_vm._s(_vm.error) + " "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-link",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.load(
                        _vm.stale ? 1 : _vm.page ? _vm.page + 1 : 1
                      )
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.stale ? "Reload contacts" : "Retry"))]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? [
            !_vm.items.length && !_vm.error
              ? _c("p", { staticClass: "small text-muted mt-2" }, [
                  _vm._v("No contacts reported."),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.items, function (entry) {
              return _c(
                "div",
                {
                  key: entry.contact.id,
                  staticClass: "registry-contact border-top py-2 mt-2",
                },
                [
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-sm btn-link p-0 font-weight-bold text-left",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.$emit("open-entity", {
                              ...entry.contact,
                              possible: _vm.possible(entry),
                            })
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.text(
                              entry.contact.name || entry.contact.full_name,
                              "Name not reported"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.possible(entry)
                      ? _c("small", { staticClass: "text-warning ml-2" }, [
                          _vm._v("Possible affiliation"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    entry.contact.titles
                      ? _c("div", { staticClass: "small text-muted" }, [
                          _vm._v(_vm._s(_vm.text(entry.contact.titles))),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small" }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.text(entry.contact.primary_email, ""))),
                    ]),
                    _c("div", [
                      _vm._v(_vm._s(_vm.text(entry.contact.primary_phone, ""))),
                    ]),
                    !entry.contact.primary_email && !entry.contact.primary_phone
                      ? _c("span", { staticClass: "text-muted" }, [
                          _vm._v("No primary email or phone"),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "details",
                    { staticClass: "small registry-contact-evidence" },
                    [
                      _c("summary", [_vm._v("Affiliation evidence")]),
                      _vm._v(" "),
                      _vm._l(_vm.matchingPaths(entry), function (path, index) {
                        return _c("div", { key: index }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                path.resolution === "ambiguous_candidate"
                                  ? "Possible affiliation"
                                  : "Reported affiliation"
                              )
                            ),
                          ]),
                          _vm._v(" · " + _vm._s(_vm.text(path.target.name))),
                          _c("pre", [_vm._v(_vm._s(_vm.json(path)))]),
                        ])
                      }),
                    ],
                    2
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _vm.items.length < _vm.total
              ? _c("p", { staticClass: "small text-muted mt-2" }, [
                  _vm._v(
                    "Showing " +
                      _vm._s(_vm.items.length) +
                      " of " +
                      _vm._s(_vm.total) +
                      " contacts."
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.page < _vm.lastPage && !_vm.stale
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-sm btn-outline-secondary",
                    attrs: { type: "button", disabled: _vm.loading },
                    on: {
                      click: function ($event) {
                        return _vm.load(_vm.page + 1)
                      },
                    },
                  },
                  [_vm._v("Load more contacts")]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }